(function (root) {
  'use strict';
  var linear = Array.from({ length: 256 }, function (_, n) {
    n /= 255;
    return n <= .04045 ? n / 12.92 : Math.pow((n + .055) / 1.055, 2.4);
  });
  function encode(n) {
    n = Math.max(0, Math.min(1, n));
    return Math.round(255 * (n <= .0031308 ? 12.92 * n : 1.055 * Math.pow(n, 1 / 2.4) - .055));
  }
  function light(data, offset) {
    return Math.round(4095 * (.2126 * linear[data[offset]] + .7152 * linear[data[offset + 1]] + .0722 * linear[data[offset + 2]]));
  }
  function wallRegion(mask, width, height, bottom) {
    var count = width * height, selected = new Uint8Array(count), queue = new Int32Array(count);
    var maxY = Math.min(height, Math.floor(height * (bottom || 1)));
    var start = Math.floor(height * .2) * width + Math.floor(width * .5), read = 0, write = 0;
    function visit(index) {
      if (index < 0 || index >= maxY * width || selected[index] || mask[index * 4] < 128) return;
      selected[index] = 1; queue[write++] = index;
    }
    visit(start);
    while (read < write) {
      var index = queue[read++], x = index % width;
      if (x > 0) visit(index - 1);
      if (x + 1 < width) visit(index + 1);
      visit(index - width); visit(index + width);
    }
    var result = new Uint8ClampedArray(mask);
    for (var p = 0; p < count; p++) if (!selected[p]) result[p * 4] = result[p * 4 + 1] = result[p * 4 + 2] = 0;
    return result;
  }
  function paint(source, mask, hex) {
    if (!/^#[0-9a-f]{6}$/i.test(hex) || source.length !== mask.length) throw new Error('Invalid wall palette');
    // Keep 12-bit linear light: 8-bit quantization bands when a dark wall becomes light.
    var histogram = new Uint32Array(4096), count = 0, reference = 4095;
    for (var i = 0; i < source.length; i += 4) {
      if (mask[i] > 248 && mask[i + 3] > 248) { histogram[light(source, i)]++; count++; }
    }
    if (!count) throw new Error('Empty wall mask');
    var cumulative = 0;
    for (var h = 0; h < 4096; h++) {
      cumulative += histogram[h];
      if (cumulative >= count * .8) { reference = Math.max(1, h); break; }
    }
    var target = [1, 3, 5].map(function (offset) { return linear[parseInt(hex.slice(offset, offset + 2), 16)]; });
    var table = Array.from({ length: 4096 }, function (_, level) {
      return target.map(function (channel) { return encode(channel * level / reference); });
    });
    var result = new Uint8ClampedArray(source);
    for (var p = 0; p < source.length; p += 4) {
      var opacity = mask[p] / 255 * mask[p + 3] / 255;
      if (!opacity) continue;
      var color = table[light(source, p)];
      for (var c = 0; c < 3; c++) result[p + c] = source[p + c] * (1 - opacity) + color[c] * opacity;
    }
    return result;
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = { paint: paint, wallRegion: wallRegion }; return; }
  var sources = new Map(), rendered = new Map();
  function load(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('Wall image unavailable')); };
      img.src = url;
    });
  }
  function prepare(m) {
    var key = m.img + '|' + m.mask + '|' + m.wallBottom;
    if (!sources.has(key)) {
      var pending = Promise.all([load(m.img), load(m.mask)]).then(function (images) {
        var canvas = document.createElement('canvas');
        canvas.width = images[0].naturalWidth; canvas.height = images[0].naturalHeight;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        if (!ctx) throw new Error('Canvas unavailable');
        ctx.drawImage(images[0], 0, 0, canvas.width, canvas.height);
        var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(images[1], 0, 0, canvas.width, canvas.height);
        var mask = wallRegion(ctx.getImageData(0, 0, canvas.width, canvas.height).data, canvas.width, canvas.height, m.wallBottom);
        return { width: canvas.width, height: canvas.height, pixels: pixels, mask: mask };
      }).catch(function (error) { sources.delete(key); throw error; });
      sources.set(key, pending);
      if (sources.size > 2) sources.delete(sources.keys().next().value);
    }
    return sources.get(key);
  }
  function render(m) {
    if (!m.mask) return Promise.resolve(m.img);
    var key = m.img + '|' + m.mask + '|' + m.wallBottom + '|' + m.hex;
    if (!rendered.has(key)) {
      var pending = prepare(m).then(function (data) {
        var canvas = document.createElement('canvas');
        canvas.width = data.width; canvas.height = data.height;
        var ctx = canvas.getContext('2d');
        ctx.putImageData(new ImageData(paint(data.pixels, data.mask, m.hex), data.width, data.height), 0, 0);
        return new Promise(function (resolve, reject) {
          canvas.toBlob(function (blob) { if (blob) resolve(URL.createObjectURL(blob)); else reject(new Error('Wall rendering failed')); }, 'image/webp', .94);
        });
      }).catch(function (error) { rendered.delete(key); throw error; });
      rendered.set(key, pending);
    }
    return rendered.get(key);
  }
  root.AfRoomWalls = { render: render, preload: function (m) { return m.mask ? prepare(m) : Promise.resolve(); } };
})(typeof window === 'undefined' ? globalThis : window);
